"use strict"; // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

Object.defineProperty(exports, "__esModule", {
  value: true
});

var QueryParameterNames =
/** @class */
function () {
  function QueryParameterNames() {}

  Object.defineProperty(QueryParameterNames, "TestHooksParamName", {
    get: function get() {
      return "testhooks";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(QueryParameterNames, "ConnectionIdHeader", {
    get: function get() {
      return "X-ConnectionId";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(QueryParameterNames, "DeploymentIdParamName", {
    get: function get() {
      return "cid";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(QueryParameterNames, "FormatParamName", {
    get: function get() {
      return "format";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(QueryParameterNames, "LanguageParamName", {
    get: function get() {
      return "language";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(QueryParameterNames, "TranslationFromParamName", {
    get: function get() {
      return "from";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(QueryParameterNames, "TranslationToParamName", {
    get: function get() {
      return "to";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(QueryParameterNames, "Profanify", {
    get: function get() {
      return "profanity";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(QueryParameterNames, "EnableAudioLogging", {
    get: function get() {
      return "storeAudio";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(QueryParameterNames, "EnableWordLevelTimestamps", {
    get: function get() {
      return "wordLevelTimestamps";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(QueryParameterNames, "InitialSilenceTimeoutMs", {
    get: function get() {
      return "initialSilenceTimeoutMs";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(QueryParameterNames, "EndSilenceTimeoutMs", {
    get: function get() {
      return "endSilenceTimeoutMs";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(QueryParameterNames, "StableIntermediateThreshold", {
    get: function get() {
      return "stableIntermediateThreshold";
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(QueryParameterNames, "StableTranslation", {
    get: function get() {
      return "stableTranslation";
    },
    enumerable: true,
    configurable: true
  });
  return QueryParameterNames;
}();

exports.QueryParameterNames = QueryParameterNames;